import {createSelector} from 'reselect';

import {externalLinkTypes} from '@/consts/externalLinkTypes';
import layoutService from '@/services/layoutService';

const selectGlobal = (state) => state.global;

const selectIsAem = createSelector(selectGlobal, (globalState) => globalState.isAem);

const selectIsAppLoading = createSelector(selectGlobal, (globalState) => globalState.isAppLoading);

const selectLayoutType = createSelector(selectGlobal, (globalState) => globalState.layout);

const selectIsXsLayout = createSelector(selectLayoutType, (layout) => layoutService.isXsLayout(layout));

const selectIsSmLayout = createSelector(selectLayoutType, (layout) => layoutService.isSmLayout(layout));

const selectIsMdLayout = createSelector(selectLayoutType, (layout) => layoutService.isMdLayout(layout));

const selectIsMlLayout = createSelector(selectLayoutType, (layout) => layoutService.isMlLayout(layout));

const selectIsLgLayout = createSelector(selectLayoutType, (layout) => layoutService.isLgLayout(layout));

const selectIsMobileLayout = createSelector(selectLayoutType, (layout) => layoutService.isMobileLayout(layout));

const selectIsMobileOnlyLayout = createSelector(selectLayoutType, (layout) => layoutService.isMobileOnlyLayout(layout));

const selectIsDesktopLayout = createSelector(selectLayoutType, (layout) => layoutService.isDesktopLayout(layout));

const selectIsDesktopOnlyLayout = createSelector(selectLayoutType, (layout) =>
    layoutService.isDesktopOnlyLayout(layout)
);

const selectLanguageCode = createSelector(selectGlobal, (globalState) => globalState.languageCode);

const selectSwMessage = createSelector(selectGlobal, (globalState) => globalState.swMessage);

const selectIsRedirectionRequiredAfterNotificationClick = createSelector(
    selectSwMessage,
    (swMessage) =>
        externalLinkTypes.isSectionLink(swMessage?.actionTypeCode) &&
        (externalLinkTypes.isAppSectionDetails(swMessage?.appSection) ||
            externalLinkTypes.isAppSectionShop(swMessage?.appSection))
);

const selectHwContainerIds = createSelector(selectGlobal, (globalState) => globalState.hwContainerIds);
const selectIsWelcomeMode = createSelector(selectGlobal, (globalState) => globalState.isWelcomeMode);
const selectIsWelcomeAnimationStarted = createSelector(
    selectGlobal,
    (globalState) => globalState.isWelcomeAnimationStarted
);
const selectIsWelcomeAnimationFinished = createSelector(
    selectGlobal,
    (globalState) => globalState.isWelcomeAnimationFinished
);

const selectPendingReturnFromWebAppConnection = createSelector(
    selectGlobal,
    (globalState) => globalState.pendingReturnFromWebAppConnection
);

const selectPendingReturnActionId = createSelector(selectGlobal, (globalState) => globalState.pendingReturnActionId);

export {
    selectHwContainerIds,
    selectIsAem,
    selectIsAppLoading,
    selectIsDesktopLayout,
    selectIsDesktopOnlyLayout,
    selectIsLgLayout,
    selectIsMdLayout,
    selectIsMlLayout,
    selectIsMobileLayout,
    selectIsMobileOnlyLayout,
    selectIsRedirectionRequiredAfterNotificationClick,
    selectIsSmLayout,
    selectIsWelcomeAnimationFinished,
    selectIsWelcomeAnimationStarted,
    selectIsWelcomeMode,
    selectIsXsLayout,
    selectLanguageCode,
    selectLayoutType,
    selectPendingReturnActionId,
    selectPendingReturnFromWebAppConnection,
    selectSwMessage,
};
